import { EXTERNAL_PATH } from 'lib/paths'

import { ExternalLink } from 'components'

const AppStoreButton = () => {
  return (
    <ExternalLink
      className="AppDownloadButton"
      href={EXTERNAL_PATH.DOWNLOAD_LINK_IOS}
    >
      <img src="/images/app-store-button.svg" />
    </ExternalLink>
  )
}

export default AppStoreButton
